import { useNavigate } from "react-router";
import { SpinnerLegacy } from "../../components";
import { useDashboardContext } from "../../components/dashboard/Dashboard.shared";
import { NavigationBar } from "../../components/navigation/NavigationBar";
import { CUSTOMER, CUSTOMER_CONVERSATION } from "../../constants/routes";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useOrder } from "../../hooks/api/v2/order/useOrder";
import { OrderContentContainer } from "../order/OrderContent/OrderContentContainer";

export const CustomerOrder = ({
  connectionId,
  orderId,
}: {
  connectionId: number;
  orderId: number;
}) => {
  const navigate = useNavigate();
  const { isTwoPanel } = useDashboardContext();

  const orderQuery = useOrder(orderId);

  return (
    <>
      <NavigationBar
        title={"Order details"}
        leftIcon={isTwoPanel ? "CLOSE" : "CHEVRON_LEFT"}
        onClickLeftIcon={() =>
          navigate(
            isTwoPanel
              ? CUSTOMER_CONVERSATION.href({ connectionId })
              : CUSTOMER.href({ connectionId }),
          )
        }
      />
      {orderQuery.isLoading ? (
        <SpinnerLegacy />
      ) : orderQuery.isError ? (
        <div>
          {apiV2AssertError(orderQuery.error)?.response?.data.message ??
            "Unknown error occurred."}
        </div>
      ) : (
        <>
          {orderQuery.data && <OrderContentContainer order={orderQuery.data} />}
        </>
      )}
    </>
  );
};
